<template>
    <div>
        <section class="content">
            <div class="container-fluid">

                <div class="row clearfix">

                    <div class="bg-light-green" style="margin-top:-1% !important;">
                        <!-- <br> -->
                        <div class="row paddingku">
                            <div class="col-md-3 searching">
                                <span class="h_page">Visi SKPD</span> <br> <br>
                            </div>
                            <div class="col-md-6">

                            </div>
                            <div class="col-md-3 searching">
                                <div class="input-group">
                                    <span class="input-group-btn">
                                        <button @click="btn_check_data_add()" type="button" class="btn bg-light-blue btn-sm waves-effect" title="Tambah Data" data-toggle="modal" data-target="#m_tambah_data"><i class="material-icons">add</i></button>
                                    </span>
                                    <input type="text" class="form-control" placeholder="Cari data" id="caridata" >
                                </div> <br>
                            </div>
                        </div>
                    </div>
                    <div class="col-xs-12 card">
                <!-- ============================================================ MULAI ======================================================================== -->
                        <br>
                        <!-- <h1>ini : {{unit_kerja_full}}</h1> -->
                        <div class="row">

                            <div class="col-md-6">
                                <span class="huruf_input">Periode Renstra</span>
                                <select class="form-control show-tick" v-model="id_renstra">
                                    <option value="" >-- Semua Periode --</option>
                                    <option v-for="data in list_Renstra" :key="data.id_renstra" :value="data.id_renstra">{{data.periode}}</option>
                                </select>
                            </div>

                            <div class="col-md-6">
                                <span class="huruf_input">Unit Kerja</span>
                                <autocomplete
                                    :url="URL+ 'api/v1/simpeg_unit_kerja/autocomplete'"
                                    :customHeaders="{authorization: 'kikensbatara '+token }"
                                    anchor="unit_kerja"
                                    :initValue="''"
                                    :placeholder="unit_kerja_full"
                                    :classes="{ input: 'form-control'}"
                                    label="writer"
                                    :onShouldRenderChild="renderChild"
                                    :on-select="getAuto">
                                </autocomplete>
                            </div>

                        </div>
                        <br>
                        
                        <br>
                        <div class="table-responsive">
                            <table class="table table-bordered" style="width: 100%">
                                <thead>
                                <tr class="bg-success kepala_table_f tabel_center">
                                    <th class="text-center" style="width: 5%">No.</th>
                                    <th class="text-center" style="width: 40%">Uraian Visi</th>
                                    <th class="text-center" style="width: 40%">Keterangan</th>
                                    <th class="text-center" style="width: 15%">#</th>
                                </tr>
                                </thead>
                                <tbody class="tabel_center" >
                                <tr class="h_isitable" v-for="(data, index) in list_data" :key="data.renstra_visi_id">
                                    <td class="tabel_center text-center">{{index+1}}</td>
                                    <td class="tabel_center">{{data.uraian}}</td>
                                    <td class="tabel_center">{{data.keterangan}}</td>

                                    <td class="tabel_center text-center" >

                                        <button @click="selectData(data)" class="btn bg-light-green btn-xs waves-effect" title="Edit Data" id="edit_data" data-toggle="modal" data-target="#m_edit_data">
                                            <i class="material-icons" >create</i>
                                        </button>
                                        &nbsp;
                                        <button @click="removeData(data.renstra_visi_id)" class="btn bg-red btn-xs waves-effect" title="Hapus Data" id="hapus_data">
                                            <i class="material-icons" >clear</i>
                                        </button>

                                    </td>
                                </tr>

                                </tbody>
                            </table>
                        </div>

                        <hr>
                            <div class="text-center">
                                <button @click="btn_prev" type="button" class="btn btn-xs bg-blue waves-effect" id="pref">
                                    <i class="material-icons">skip_previous</i>
                                </button>
                                &nbsp;
                                <span style="font-size: 85%; color: #a5a5a5">
                                    <b>{{page_first}} - {{page_last}}</b>
                                </span>
                                &nbsp;
                                <button @click="btn_next" type="button" class="btn btn-xs bg-blue waves-effect" id="next">
                                    <i class="material-icons">skip_next</i>
                                </button>
                            </div>
                        <hr>


                        <!-- ============================================================ MODAL ======================================================================== -->


                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_tambah_data" tabindex="-1" role="dialog">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-blue">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">TAMBAH DATA</h4>
                                        </div>

                                        <form @submit.prevent="addData()">

                                            <div class="modal-body">
                                                <div v-if="!check_data_add" class="alert alert-info text-center">
                                                    <strong>SILAHKAN PILIH PERIODE RENSTRA TERLEBIH DAHULU!</strong> 
                                                </div>

                                                <div v-if="check_data_add">

                                                    <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">Uraian Visi</label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <input v-model="uraian" type="text" class="datepicker form-control" >
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                    <div class="row clearfix">
                                                        <div class="col-md-2 form-control-label">
                                                            <label for="kode">Keterangan </label>
                                                        </div>
                                                        <div class="col-md-10">
                                                            <div class="form-group">
                                                                <div class="form-line">
                                                                    <textarea :required="true" v-model="keterangan" rows="4" class="form-control no-resize"></textarea>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-info waves-effect">SIMPAN</button>
                                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL TAMBAH xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->


                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                            <div class="modal fade" id="m_edit_data" tabindex="-1" role="dialog">
                                <div class="modal-dialog modal-lg" role="document">
                                    <div class="modal-content">
                                        <div class="modal-header bg-light-green">
                                            <button @click="emptyData()" type="button" class="close" data-dismiss="modal" aria-label="Close">
                                                <span aria-hidden="true">&times;</span></button>
                                            <h4 class="modal-title" id="largeModalLabel">EDIT DATA</h4>
                                        </div>
                                        <form @submit.prevent="editData()">
                                            <div class="modal-body">
                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Uraian Visi</label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <input v-model="uraian" type="text" class="datepicker form-control" >
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                                <div class="row clearfix">
                                                    <div class="col-md-2 form-control-label">
                                                        <label for="kode">Keterangan </label>
                                                    </div>
                                                    <div class="col-md-10">
                                                        <div class="form-group">
                                                            <div class="form-line">
                                                                <textarea :required="true" v-model="keterangan" rows="4" class="form-control no-resize"></textarea>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>

                                            </div>
                                            <div class="modal-footer">
                                                <button type="submit" class="btn btn-success waves-effect">RUBAH</button>
                                                <button type="button" class="btn btn-danger waves-effect" data-dismiss="modal">KEMBALI</button>
                                            </div>
                                        </form>
                                    </div>
                                </div>
                            </div>
                        <!-- xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx MODAL EDIT xxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxxx -->
                        <!-- ============================================================ MODAL ======================================================================== -->
                <!-- ============================================================ MULAI ======================================================================== -->
                    </div>

                </div>

            </div>
      </section>



    </div>
</template>


<script>

    const ADD_URL = URL_APP+'api/v1/planning_renstra_visi/';
    const ADD_URL_RENSTRA = URL_APP+'api/v1/planning_renstra_renstra/';
    const ADD_URL_UNIT_KERJA = URL_APP+'api/v1/simpeg_unit_kerja/';
    const URL_SERVER = URL_APP;
    import Autocomplete from 'vue2-autocomplete-js'


    export default {
        name: "planning_rpjmd",
        components: { Autocomplete },
        data() {
            return {
                renstra_visi_id : '',
                uraian : '',
                keterangan : '',
                id_renstra : '',

                unit_kerja : '',
                unit_kerja_full : '',
                unit_kerja_edit : '',

                check_data_add : false,

                list_Renstra: [],

                list_data : [],
                page_first : 1,
                page_last : 0,
                cari_value : '',

                token : localStorage.token,
                URL : URL_SERVER
            };
        },

        mounted() {
            var get_profile = JSON.parse(localStorage.profile);
            this.unit_kerja_full = get_profile.profile.unit_kerja_nama;
            this.unit_kerja = get_profile.profile.unit_kerja;


            this.getData();
            this.getRenstra();
            localStorage.sidemenu = 'planing';
        },

        // =============================================================== METHODS =========================================================================
        methods : {
            addData: function(){
                fetch(ADD_URL+'createData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara "+ localStorage.token
                    },

                    body: JSON.stringify({
                        uraian : this.uraian,
                        keterangan : this.keterangan,

                        id_renstra : this.id_renstra,
                        unit_kerja : this.unit_kerja,
                    })


                }).then(res => res.json()).then((data_rpjmd) => {
                    this.alertku('success', 'Berhasil Menambah Data!');
                    this.getData();
                });
            },
            getData: function(){
                fetch(ADD_URL+'readData', {
                    method : 'POST',
                    headers : {
                      "content-type": "application/json",
                      authorization: "kikensbatara " + localStorage.token
                    },
                    body : JSON.stringify({
                      data_ke : this.page_first,
                      cari_value : this.cari_value,
                      id_renstra : this.id_renstra,
                      unit_kerja : this.unit_kerja
                    })
                }).then((res) => res.json()).then((res_data) => {
                  this.list_data = res_data.data;
                  this.page_last = res_data.jml_data;
                //   console.log(res_data);
                })
            },
            editData: function(){
                fetch(ADD_URL+'updateData', {
                    method: 'POST',
                    headers: {
                        "content-type": "application/json",
                        authorization: "kikensbatara " + localStorage.token
                    },
                    body: JSON.stringify({
                        renstra_visi_id : this.renstra_visi_id,
                        uraian : this.uraian,
                        keterangan : this.keterangan,

                        unit_kerja : this.unit_kerja_edit,
                    })
                }).then((res_data) => {
                //   console.log(res_data);
                    this.alertku("success", "Berhasil Mengubah Data!");
                    this.getData();
                });
            },
            selectData : function(data){
                this.renstra_visi_id = data.renstra_visi_id;
                this.uraian = data.uraian;
                this.keterangan = data.keterangan;
                this.id_renstra = data.id_renstra;
                this.unit_kerja_edit = data.unit_kerja;
            },
            removeData : function(id){
                this.$swal({
                  title: 'Apa Anda Ingin Menghapus Data?',
                  text: 'Data Yang Telah Dihapus Tidak Dapat Dikembalikan',
                  type: 'warning',
                  showCancelButton: true,
                  confirmButtonText: 'Ya',
                  cancelButtonText: 'Batal',
                  showCloseButton: true,
                  showLoaderOnConfirm: true
                }).then((result) => {
                  if(result.value) {
                    fetch(ADD_URL+"deleteData", {
                        method : 'POST',
                        headers : {
                          'content-type' : 'application/json',
                          authorization : "kikensbatara "+ localStorage.token,
                        },
                        body : JSON.stringify({
                          id : id,
                        })
                    }).then(()=>{
                        this.alertku("success", "Sukses Menghapus Data!");
                        this.getData();
                    });
                    this.$swal('Terhapus', 'Berhasil Menghapus Data!', 'success')
                  } else {
                    this.$swal('Batal', 'Batal Menghapus Data!', 'info')
                  }
                })
            },
            emptyData : function(){
                this.renstra_visi_id = '';
                this.uraian = '';
                this.keterangan = '';
                this.id_renstra = '';
            },

        //TAMBAHAN
            getRenstra : function(){
                this.page_first = 1;
                fetch(ADD_URL_RENSTRA, {
                    method : 'POST',
                    headers : {
                        'content-type': 'application/json',
                        authorization : 'kikensbatara '+ localStorage.token
                    },
                    body : JSON.stringify({
                        unit_kerja : this.unit_kerja
                    })
                }).then(res => res.json()).then((res_data)=>{
                    this.list_Renstra = res_data;
                    this.getData();
                    // console.log(res_data);
                })
            },

        //TAMBAHAN

        // ================== AUTOCOMPLETE ====================
            renderChild(data) {
                return `
                <span><b>${data.unit_kerja}</b></span>
                <span style='font-size:80%'>${data.ref_instansi}</span>
                `
            },
            getAuto : function(obj){
                this.unit_kerja = obj.id;
                this.unit_kerja_full = obj.unit_kerja;
                this.getData();
                this.getRenstra();
                // console.log(obj);
            },
        // ================== AUTOCOMPLETE ====================
        
        // ================== PAGINASI ====================
            alertku : function(type, title){
                this.$swal({
                    type: type,
                    title: title,
                    showConfirmButton: false,
                    timer: 800
                });
            },

            btn_prev : function(){
                if(this.page_first>1){
                    this.page_first--
                }else{
                    this.page_first = 1;
                }
                this.getData();
            },

            btn_next : function(){
                if(this.page_first >= this.page_last){
                    this.page_first == this.page_last
                }else{
                    this.page_first++;
                }
                this.getData();
            },

            cari_data : function(){
                this.page_first = 1;
                this.getData();
            },
            btn_check_data_add : function(){
                if (this.id_renstra != '') {
                    this.check_data_add = true;
                }
            } 
        // ================== PAGINASI ====================
        },
        // =============================================================== METHODS =========================================================================

    };
</script>
